import { ISiteBridgeSettingsForSiteAdmin } from '~src/settings/types/ISiteAdminBridgeSettings';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetSiteBridgeSettingsForSiteAdminParams {
  id: string;
}

export type IGetSiteBridgeSettingsForSiteAdminResult = IResult & ISiteBridgeSettingsForSiteAdmin;

export class GetSiteBridgeSettingsForSiteAdminRequest
  extends Request<IGetSiteBridgeSettingsForSiteAdminParams, IGetSiteBridgeSettingsForSiteAdminResult>
{
  constructor(params: IGetSiteBridgeSettingsForSiteAdminParams) {
    super('getSiteBridgeSettingsForSiteAdmin', params);
  }
}
